import { render, staticRenderFns } from "./editTemplate.vue?vue&type=template&id=13b44bf8&scoped=true"
import script from "./editTemplate.vue?vue&type=script&lang=js"
export * from "./editTemplate.vue?vue&type=script&lang=js"
import style0 from "./editTemplate.vue?vue&type=style&index=0&id=13b44bf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b44bf8",
  null
  
)

export default component.exports